import React from "react";
import { ChannelList, InfiniteScroll } from "stream-chat-react";
import { useTranslation } from "react-i18next";
import { useStreamChatSession } from "@/components/chat/ChatProvider";
import { DashboardChatListItem } from "@/components/pages/dashboard/components/DashboardChatListItem";
import { buildDashboardGuestChatsFilters } from "@/components/pages/dashboard/utils/dashboardGuestChatsFilters";

const DashboardChatsEmptyState = () => {
  const { t } = useTranslation();

  return (
    <div className="flex h-full min-h-24 items-center justify-center px-4 text-center">
      <p className="text-sm text-neutral-400">{t("chats.dashboardEmpty")}</p>
    </div>
  );
};

export const DashboardChatsContainer = () => {
  const { streamUserId, streamSessionReady } = useStreamChatSession();

  if (!streamSessionReady || !streamUserId) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <p className="text-sm text-neutral-400">Loading chats...</p>
      </div>
    );
  }

  return (
    <ChannelList
      filters={buildDashboardGuestChatsFilters(streamUserId)}
      sort={{ last_message_at: -1 }}
      options={{ presence: true, state: true }}
      Preview={DashboardChatListItem}
      Paginator={InfiniteScroll}
      EmptyStateIndicator={DashboardChatsEmptyState}
    />
  );
};
